var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4484_1054)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.512212 11.8564C0.511649 13.8728 1.04265 15.8418 2.05234 17.5772L0.415649 23.5067L6.53115 21.9156C8.22261 22.8293 10.1178 23.3081 12.0436 23.3082H12.0487C18.4064 23.3082 23.5816 18.1749 23.5844 11.8654C23.5856 8.808 22.3867 5.93302 20.2085 3.77005C18.0307 1.60726 15.1343 0.415534 12.0482 0.414139C5.68984 0.414139 0.514931 5.54716 0.512306 11.8564",
    fill: "url(#paint0_linear_4484_1054)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.06358 6.89749C8.8399 6.40419 8.60449 6.39423 8.39177 6.38558C8.21758 6.37814 8.01846 6.3787 7.81952 6.3787C7.6204 6.3787 7.29687 6.45302 7.0234 6.7493C6.74965 7.04586 5.97827 7.76251 5.97827 9.22009C5.97827 10.6778 7.04824 12.0864 7.1974 12.2843C7.34674 12.4818 9.26299 15.5687 12.2979 16.7562C14.8201 17.7431 15.3334 17.5468 15.8808 17.4973C16.4283 17.448 17.6474 16.7808 17.8961 16.089C18.1451 15.3973 18.1451 14.8044 18.0704 14.6805C17.9958 14.557 17.7967 14.4829 17.4981 14.3348C17.1994 14.1866 15.7315 13.4699 15.4578 13.371C15.1841 13.2722 14.985 13.2229 14.7859 13.5195C14.5868 13.8157 14.015 14.4829 13.8407 14.6805C13.6666 14.8785 13.4923 14.9032 13.1938 14.755C12.8951 14.6063 11.9335 14.2939 10.7926 13.2847C9.90499 12.4993 9.30574 11.5296 9.13155 11.2329C8.95737 10.9367 9.1129 10.7762 9.26262 10.6286C9.39677 10.4958 9.5613 10.2826 9.71074 10.1097C9.85962 9.93665 9.9093 9.81321 10.0089 9.61563C10.1085 9.41786 10.0586 9.24484 9.98412 9.09665C9.9093 8.94847 9.32908 7.48335 9.06358 6.89758",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4484_1054",
    x1: 12,
    y1: 23.5067,
    x2: 12,
    y2: 0.414139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4484_1054"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappIcon);
export default __webpack_public_path__ + "static/media/whatsapp_icon.09322f1c83c8c11772a525685ff6ef3c.svg";
export { ForwardRef as ReactComponent };